const ɵ0 = (moment) => {
    return (input) => {
        return moment(input).format("MMM DD, YYYY hh:mm A");
    };
};
const filter = ['moment', ɵ0];
export const FourDotFiveTimeStampFormatFilter = {
    name: 'fourdotfiveTimeStampFormat',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-time-stamp-format.filter.js.map